export default __webpack_public_path__ + "static/media/authTemplate-bg.fb4b6c21.svg";